module.exports = __webpack_public_path__ + "static/img/2_1.a2de9831.png";